<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, /* structural elements 结构元素 */
dl, dt, dd, ul, ol, li, /* list elements 列表元素 */
pre, /* text formatting elements 文本格式元素 */
form, fieldset, legend, button, input, textarea, /* form elements 表单元素 */
th, td /* table elements 表格元素 */
img {
  margin: 0;
  padding: 0;
}
img{
  border:0 ;
}
a{
  text-decoration: none;
}
.cl{
  clear: both;
}
.ov{
  overflow: hidden;
}

ul{
  list-style: none;
}
.banxin{
  width: 1200px;
  margin: 0 auto;
}
.fl{
  float: left;
}
.fr{
  float: right;
}
body{
  font-family: "微软雅黑";
}
h1,h2,h3,h4,h5{
  font-weight: 400;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue